import { CommonDialogs } from "@mcleod/common";
import { DataSource } from "@mcleod/components";
import { Api } from "@mcleod/core";

interface SingleActiveProps {
    tableName: string;
    activeFlag: string;
    datasource: DataSource;
}
export class SingleActive {

    static configureActiveFlag(props: SingleActiveProps) {
        const existingCallback = props.datasource.doBeforeDataSourcePost;
        props.datasource.doBeforeDataSourcePost = async (): Promise<boolean> =>
            this.checkIfAnotherActive(props.tableName, props.activeFlag, props.datasource)
                .then(shouldContinue =>
                    (shouldContinue && existingCallback) ? existingCallback() : shouldContinue
                );
    }

    static async checkIfAnotherActive(table: string, active_field: string, datasource: DataSource): Promise<boolean> {
        if (datasource.activeRow.get("is_active") === "Y" && datasource.activeRow.getChangedData()?.is_active != null) {
            const response = await Api.post("lme/dispatch/check-active-field", {
                id: datasource.activeRow.get("id"),
                table,
                active_field
            });

            const resultData = response?.data?.[0];
            if (resultData?.has_active) {
                const userConfirmed = await CommonDialogs.showYesNo(resultData.prompt_message);
                if (userConfirmed) {
                    const row = await datasource.createBlankRow();
                    row.setValues(resultData.row_to_update);
                    row._appending = false;
                    row["_originalData"] = resultData.row_to_update;
                    row.set(active_field, "N");
                    await row.post();
                    return true;
                }
                return false;
            }
        }
        return true;
    }
}